import { QueryOptionsType, Product } from "@framework/types";
import { API_ENDPOINTS } from "@framework/utils/api-endpoints";
import http from "@framework/utils/http";
import { useInfiniteQuery } from "react-query";
type PaginatedProduct = {
  results: Product[];
  paginatorInfo: {
    offset: number;
    limit: number;
    total?: number;
  };
};
const fetchProducts = async ({
  queryKey,
  pageParam = 0
}: any) => {
  const [_key, _params] = queryKey;
  const {
    limit = 10,
    ...params
  } = _params;
  const offset = pageParam;
  const queryString = new URLSearchParams({
    ...params,
    offset: offset.toString(),
    limit: limit.toString()
  }).toString();
  const url = `${API_ENDPOINTS.PRODUCTS}?${queryString}`;
  try {
    const {
      data
    } = await http.get(url);
    return {
      results: data.results || data.data || data.products,
      paginatorInfo: {
        offset: offset + limit,
        limit,
        total: data.total || data.paginatorInfo?.total
      }
    };
  } catch (error) {
    throw error;
  }
};
const useProductsQuery = (options: QueryOptionsType) => {
  return useInfiniteQuery<PaginatedProduct, Error>([API_ENDPOINTS.PRODUCTS, options], fetchProducts, {
    getNextPageParam: lastPage => {
      return lastPage.results.length === lastPage.paginatorInfo.limit ? lastPage.paginatorInfo.offset : undefined;
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};
export { useProductsQuery, fetchProducts };